import { Component, OnInit, Input } from '@angular/core';
import { DealProcessModel } from '@models/deal.model';

@Component({
    selector: 'app-process',
    templateUrl: './process.component.html',
    styleUrls: ['./process.component.scss'],
})
export class ProcessComponent implements OnInit {
    @Input() process: DealProcessModel;

    constructor() {}

    ngOnInit(): void {}
}
